import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { Logo } from "./Logo";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/5 py-10 mt-0">
      <div className="glow-line absolute top-0 left-0 right-0" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-5">
        <div className="flex items-center gap-4">
          <Logo size="sm" />
          <span className="text-xs font-body text-[#9BA1B0]">— {t.footer.tagline}</span>
        </div>
        <div className="text-xs font-body text-[#5C6370]">
          © {year} BE1. {t.footer.rights}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
